'use strict';

var template = require('commons/templates/ActionLogContent.ejs');
var RowTpl = require('commons/templates/ActionLogRow.ejs');
var ShowMoreBtnTpl = require('commons/templates/ActionLogShowMoreBtn.ejs');
var loader = require('helpers/loader');

module.exports = Backbone.View.extend({
    tabName:   'div',

    initialize: function(options) {
        this.limit = (this.collection.pagination || {}).limit || 10;
        this.skip = 0;
        this.fetchMore = options.fetchMore;
        this.layerMap = options.layerMap;
    },

    events: {
        'click .js-show-more-btn': 'showMore'
    },

    render: function() {
        var showMoreBtn = ShowMoreBtnTpl();
        this.$el.html(template({
            collection: this.collection,
            RowTpl: RowTpl,
            showMoreBtn: showMoreBtn,
            limit: (this.collection.pagination || {}).limit || this.limit
        }));
        this.appendActionLogs(this.collection);
        return this;
    },

    showMore: function(e) {
        var skip = this.skip + this.limit;
        var stopLoader = loader.startFullScreen(e.currentTarget);

        this.fetchMore({
            skip: skip,
            limit: this.limit
        }).then(function(actionLogs) {
            this.skip += this.limit;
            this.appendActionLogs(actionLogs);
        }.bind(this)).finally(stopLoader);
    },

    appendActionLogs: function(actionLogs) {
        if (!actionLogs.length) {
            this.$('.js-show-more-btn').hide();
        }

        Promise.each(actionLogs, actionLog => {
            const {leaveTypeName} = (actionLog.get('metadata') || {});

            return actionLog.fetchEmployee()
                .then(
                    () => leaveTypeName ?
                        Promise.resolve() : actionLog.fetchLeaveType()
                )
                .then(
                    () => {
                        this.$('tbody').append(RowTpl({
                            actionLog: actionLog,
                            employee: actionLog.getEmployee(),
                            leaveTypeName: leaveTypeName ||
                                (actionLog.getLeaveType()).get('name'),
                            layer: this.layerMap &&
                                this.layerMap[actionLog.get('employeeId')] || 0
                        }));
                        return Promise.resolve(true);
                    }
                );
        });
    }
});



// WEBPACK FOOTER //
// ./app/commons/views/ActionLog.js